export default __webpack_public_path__ + "static/media/menu.d54fd129.svg";